<div class="forward-form-container">
    @if (!isLoaded) {
        <sb-loader></sb-loader>
    } @else {
        <!--    todo: why component below is named modal-->
        <app-forward-message-modal [forwardTicketData]="forwardTicketData"></app-forward-message-modal>
    }
</div>
